<template>

  <div class="wrap">
    <Nav :activeId="activeId" />

    <div class="page-banner" style="position: relative;">
      <!-- <img :src="require(`@/img/news/detail/banner/${id}.jpg`)" class="bg" /> -->
      <img :src="detail.img" class="bg" />

      <div class="mask">
        <img src="../../img/news/mask-bg.png" />
        <div class="layer">
          <div class="layer-title">{{ detail.title }}</div>
          <!-- <img src="../../img/news/btn-read.png" class="layer-btn"> -->
        </div>
      </div>
    </div>

    <div class="section-one self-bg">
      <div class="content-pic">
        <div v-html="detail.content"></div>
        <!-- <img :src="require(`@/img/news/detail/content/${id}.jpg`)" /> -->
      </div>
    </div>

    <Footer />
  </div>

</template>

<script>
import { getNewsDetail } from "@/api/index";
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 0,
      id: 1,
      detail: [],
      list: [
        {
          id: 1,
          title: '水启·聚势·谋远 | 2023班尼戈全国经销商大会经典回顾'
        },
        {
          id: 2,
          title: '黔城共鉴,筑新征程 | 西南区域首家班尼戈贵阳活水体验中心盛大开业'
        },
        {
          id: 3,
          title: '群贤毕至,共襄盛举 | 2023中外豪宅设计T20峰会 引领高净值人士居住新理念'
        },
        {
          id: 4,
          title: '现场直击 | 班尼戈水暖系统 重磅亮相2023北京ISH展'
        },
        {
          id: 5,
          title: '水由新生·境启未来 | 德国班尼戈 X 设计大咖齐聚蓉城 开启六维水管理健康之旅'
        }
      ]
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    this.id = this.$route.params.id
    // this.detail = this.list.find(item => item.id == this.id)
    console.log(this.id)
    // console.log(this.detail)

    // 加载数据
    this.loadData(this.id);
  },
  methods: {
    loadData(id) {
      getNewsDetail({id}).then((res) => {
        console.log(res);
        this.detail = res.data.data;
      });
    },
  }
};
</script>

<style scoped lang="less">
.page-banner {
  .bg {
    // max-height: 721px;
    // object-fit: fill;
  }
}
.self-bg {
  min-height: 500px;
  // padding: 30px 0;
  background-color: #FFF;
  overflow: auto;
  padding: 100px 0 200px;
}
.sub-title {
  width: 1100px;
  margin: 0 auto 50px;
  img {
    width: 100%;
    height: auto;
  }
}
.content-pic {
  width: 1100px;
  height: auto;
  margin: 0 auto;
  color: #000000;
  font-size: 16px;
  line-height: 180%;
  font-weight: lighter;
  img {
    width: 100%;
    height: auto;
  }
  p {
    line-height: 180%;
    font-weight: lighter;
  }
}
.mask {
  width: 100%;
  position: absolute;
  bottom: 0;
  .layer {
    width: 1100px;
    position: absolute;
    margin: 0 auto;
    // top: 50%;
    // padding: 0 50px;
    left: 0;
    right: 0;
    bottom: 30px;
    color: #FFF;
    text-align: left;
    .layer-title {
      font-size: 24px;
      // font-weight: bold;
      margin-bottom: 10px;
    }
    .layer-btn {
      width: 139px;
      height: 29px;
    }
  }
}
</style>